import commaUp from '../../../assets/images/solution/community/comma-up.png'
import commaDown from '../../../assets/images/solution/community/comma-down.png'
import commaUp2 from '../../../assets/images/solution/community/comma-dxsj.png'

import divide2 from '../../../assets/images/solution/community/divide2.png'

import sqgzwl from '../../../assets/images/solution/community/5gsqgzwl.png'
import sqdsjzx from '../../../assets/images/solution/community/sqdsjzx.png'
import zhsqyy from '../../../assets/images/solution/community/zhsqyy.png'

import styles from './style.module.scss'

function SmartCommunity() {
    return (
        <div className={`solution-introduction-wrapper ${styles['community-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className='title'>智慧社区</div>
                <div className='content'>覆盖物业管理、产量情况、人员出入、户籍迁移等一站式社区管理平台</div>
            </div>
            <div className={`introduction-wrapper ${styles['introduction-wrapper']}`}>
                <p className='title'>方案简介</p>
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div>
                        <img src={commaUp} alt="" />
                        <p>智慧社区</p>
                        <p>社区治理是数字政府建设的重要基石，烽火星空面向基层管理人员打造覆盖物业管理、产量情况、人员出入、户籍迁移等一站式社区管理平台，为社区提供高质量、高效率服务，助力实现共建共治共享的智慧社区新格局。</p>
                        <img src={commaDown} alt="" />
                    </div>
                </div>
            </div>
            <div className={styles['introduction-content']}>
                <div className={styles['introduction-item']}>
                    <p className={styles['title']}>5G社区感知网络</p>
                    <p className={styles['sub-title']}>做社区的千里眼、顺风耳、通灵鼻</p>
                    <img src={divide2} alt="" />
                    <img src={sqgzwl} alt="" />
                </div>
                <div className={styles['introduction-item']}>
                    <p className={styles['title']}>社区大数据中心</p>
                    <p className={styles['sub-title']}>为社区一房一车一人一物建立数字档案</p>
                    <img src={divide2} alt="" />
                    <img src={sqdsjzx} alt="" />
                </div>
                <div className={styles['introduction-item']}>
                    <p className={styles['title']}>智慧社区应用</p>
                    <p className={styles['sub-title']}>提升人民群众的获得感、幸福感、安全感</p>
                    <img src={divide2} alt="" />
                    <img src={zhsqyy} alt="" />
                </div>
            </div>
            <div className={`achievement-wrapper ${styles['achievement-wrapper']}`}>
                <p className='title'>典型实践</p>
                <div className={styles['achievement-container']}>
                    <div>
                        <img src={commaUp2} alt="" />
                        <p>方案应用</p>
                        <p>烽火星空以南京仙林某小区为试点，将其打造为智慧社区，满足群租管理、邻里纠纷、扶贫助弱、疫情防控等城市治理最小单元的管理需求，保证社区周边出现的问题都能够即时发现、及时处理、及时解决，开创社区管理新局面。</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SmartCommunity